import React from 'react';
import { useSelector } from 'react-redux';

import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import styles from './PendingTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import PendingTableHeader from '../PendingTableHeader';
import PendingTableRow from '../PendingTableRow';
import {
  currentPageSelector,
  NeovarsityManagementPagination,
  useGetCapstoneSubmissionsQuery,
} from 'features/neovarsityManagement';

function PendingTable() {
  const currentPage = useSelector(currentPageSelector);
  const { data, isLoading, error, refetch, isFetching } =
    useGetCapstoneSubmissionsQuery({
      type: 'pending',
      page: currentPage,
    });

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load capstone submissions"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data?.length > 0) {
    const capstoneSubmissions = data.data;

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <Table className={styles.root}>
          <PendingTableHeader />
          <TableBody className={styles.rows}>
            {capstoneSubmissions?.map((submission) => (
              <PendingTableRow
                submission={submission}
                key={submission.id}
              />
            ))}
          </TableBody>
        </Table>
        <ElementSpacePlaceholder elementId="pending-submission-pagination" />
        <div
          id="pending-submission-pagination"
          className={styles.pagination}
        >
          <NeovarsityManagementPagination
            pageCount={data.meta.total_pages}
            currentPage={currentPage}
          />
        </div>
      </>
    );
  } else {
    return (
      <ErrorLayout
        title="No capstone submissions found!"
        message="No submissions to take actions on at the moment!"
      />
    );
  }
}

export default PendingTable;
